import { classNames } from '@bytel/product-wall/helpers';
import {
    Alignable,
    Box,
    BoxContent,
    Column,
    Columns,
    GapSize,
    Icon,
    IconName,
    IconSize,
    Popover,
    PopoverDirection,
    Switch,
    Text,
    TextLevels,
    TextMarkup,
    TypographyBold,
    View,
} from '@bytel/trilogy-react';

import { BigIcon, BigIconVariant } from '@components/big';

import { MarketingsState, PartialMarketingsState } from '@hooks/use-marketings';

import { MarketingType } from '@constants/plan';

import { sendPromoConfiguratorTracking } from '@home-fai/helpers';

interface PromoConfiguratorProps {
    removeRadius?: boolean;
    isFullwidth?: boolean;
    marketingsState: MarketingsState;
    setMarketingsState: (marketings: PartialMarketingsState) => MarketingsState;
}

export function PromoConfigurator({
    removeRadius = false,
    isFullwidth = false,
    marketingsState,
    setMarketingsState,
    ...props
}: Readonly<PromoConfiguratorProps>) {
    return (
        <Box
            className={classNames(
                'promo-configurator',
                removeRadius ? 'is-radiusless' : '',
                isFullwidth ? 'is-fullwidth' : 'w-fit',
            )}
            {...props}
        >
            <BoxContent>
                <Columns mobile align={Alignable.ALIGNED_CENTER} gap={GapSize.TWO} className='gap-big-mobile'>
                    <Column narrow>
                        <Columns
                            verticalAlign={Alignable.ALIGNED_CENTER}
                            className='is-order-reversed-mobile gap-medium'
                        >
                            <Column narrow>
                                <View flexable className='has-custom-big-background big-icon w-fit'>
                                    <BigIcon
                                        height={16}
                                        variant={BigIconVariant.INFO}
                                        style={{
                                            opacity: marketingsState[MarketingType.MOBILE] ? '100%' : '30%',
                                            filter: marketingsState[MarketingType.MOBILE] ? 'none' : 'grayscale(100%)',
                                            transition: 'ease-in .1s',
                                        }}
                                    />
                                </View>
                            </Column>
                            <Column>
                                <Switch
                                    className='centered-switch'
                                    checked={marketingsState[MarketingType.MOBILE]}
                                    onChange={({ switchState }) => {
                                        sendPromoConfiguratorTracking(switchState);
                                        setMarketingsState({ [MarketingType.MOBILE]: switchState });
                                    }}
                                />
                            </Column>
                        </Columns>
                    </Column>
                    <Column narrow>
                        <Columns mobile verticalAlign={Alignable.ALIGNED_CENTER} gap={GapSize.ONE}>
                            <Column>
                                <Columns
                                    verticalAlign={Alignable.ALIGNED_CENTER}
                                    gap={GapSize.TWO}
                                    className='gap-smaller-mobile'
                                >
                                    <Column narrow>
                                        <Text
                                            level={TextLevels.TWO}
                                            typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD}
                                            marginless
                                            markup={TextMarkup.SPAN}
                                        >
                                            Voir les prix avec forfait mobile
                                        </Text>
                                    </Column>
                                    <Column narrow>
                                        <Text level={TextLevels.TWO} marginless markup={TextMarkup.SPAN}>
                                            Si vous avez ou prenez un forfait Bouygues Telecom.
                                        </Text>
                                    </Column>
                                </Columns>
                            </Column>
                            <Column narrow verticalAlign={Alignable.ALIGNED_CENTER}>
                                <Popover
                                    direction={PopoverDirection.LEFT}
                                    trigger={<Icon name={IconName.INFOS_CIRCLE} size={IconSize.SMALL} />}
                                >
                                    Avec un forfait Bouygues Telecom de 20 Go ou plus (hors forfaits B&YOU) vous
                                    économisez chaque mois sur votre box et sur votre forfait mobile.
                                </Popover>
                            </Column>
                        </Columns>
                    </Column>
                </Columns>
            </BoxContent>
        </Box>
    );
}
